import { AbstractControl, ValidationErrors } from "@angular/forms";

export class PortAgentForm {
    country: string | null = null;
    country_id: number | null = null;
    portName: string | null = null;
    port_id: number | null = null;
    imoNumber: number | null = null;
    vessel: string | null = null;
    NRT: number | null = null;
    GRT: number | null = null;
    RGRT: number | null = null;
    LOA: number | null = null;
    Beam: number | null = null;
    Depth: number | null = null;
    type: string | null = null;
    dwt: number | null = null;
    purpose: string | null = null;
    purpose_id: number | null = null;
    cargo: string | null = null;
    cargo_id: number | null = null;
    eta: string | null = null;
    etd: string | null = null;
    vesselStay: string | null = null;
    pda_roe: string | null = null;
    voyage: string | null = null;
    services: PA_Item[] | [] = [];
    constructor(portAgentForm?: Partial<PortAgentForm>) {
        Object.assign(this, portAgentForm);
    }
}
export class SubService {
    name: any;
    purpose: any;
    basic_value: any;
    unique_key: any;
    calculated_basic_value: any;
    movement: any;
    tariff_percent: any;
    formula_result: any;
    optional: any;
    hide: any;
    operational_flag: any;
    sub_total: any;
    formula_inputs: any ;
    reference: any;

    constructor(data?: Partial<SubService>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class Item {
    SNO: number | null = null;
    code: number | null = null;
    total: number | null = null;
    service: string | null = null;
    purpose: string | null = null;
    feedback: string | null = null;
    pa_remark: string | null = null;
    meraki_feedback: string | null = null;
    meraki_remark_client: string | null = null;
    client_comment: string | null = null;
    client_option: string | null = null;
    info_msg: string | null = null;
    negotiate: string | null = null;
    agreed: string | null = null;
    subService: SubService[] = [];

    constructor(data?: Partial<Item>) {
        if (data) {
            Object.assign(this, data);
            if (data.subService) {
                this.subService = data.subService.map(s => new SubService(s));
            }
        }
    }
}

export class AdditionalCharge {
    name: string | null = null;
    basic_value: number | null = null;
    rate: number | null = null;
    formula_result: string | null = null;
    total: number | null = null;

    constructor(data?: Partial<AdditionalCharge>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class Rules {
    items: Item[] = [];
    grand_total: number | null = null;

    constructor(data?: Partial<Rules>) {
        if (data) {
            Object.assign(this, data);

            if (data.items) {
                this.items = data.items.map(i => new Item(i));
            }

        }
    }
}

export class PA_Rules {
    items: PA_Item[] = [];
    grand_total: any ;

    constructor(data?: Partial<PA_Rules>) {
        if (data) {
            Object.assign(this, data);

            if (data.items) {
                this.items = data.items.map(i => new PA_Item(i));
            }

        }
    }
}

export class PA_Item {
    SNO:any;
    code: any;
    total: any = '';
    service: any ;
    purpose: any ;
    pa_remark: any ;
    meraki_feedback: any ;
    meraki_remark_client: any ;
    client_comment: any ;
    client_option: any ;
    info_msg: any ;
    negotiate: any ;
    agreed: any ;
    display_to_client: any ;
    subService: SubService[] = [];

    constructor(data?: Partial<PA_Item>) {
        if (data) {
            Object.assign(this, data);
            if (data.subService) {
                this.subService = data.subService.map(s => new SubService(s));
            }
        }
    }
}


interface SelectOption {
    id: number | string;
    name: string;
    type?: string;
}

export class Field {
    name: string = '';
    value: string = '';
    type: 'input' | 'select' | 'date' = 'input';
    data_type: string = '';
    options?: SelectOption[] | [] | null;
    PAForm?: boolean = false;
    readOnly?: boolean = false;
    createPdaForm?: boolean = false;
}

const fields: Field[] = [
    { name: 'Client', value: 'client_id', type: 'select', data_type: 'number', options: [], PAForm: false, readOnly: false, createPdaForm: true },
    { name: 'Port Agent', value: 'portagent_id', type: 'select', data_type: 'number', options: [], PAForm: false, readOnly: false, createPdaForm: true },
    { name: 'Country', value: 'country_id', type: 'select', data_type: 'text', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Port', value: 'port_id', type: 'select', data_type: 'text', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'IMO Number', value: 'imo_number', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Vessel', value: 'vessel', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'NRT', value: 'nrt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'GRT', value: 'grt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'RGRT', value: 'rgrt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'LOA', value: 'loa', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Beam', value: 'beam', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Depth', value: 'depth', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Dead Weight', value: 'dwt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Cargo', value: 'cargo_id', type: 'select', data_type: 'number', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Purpose', value: 'purpose_id', type: 'select', data_type: 'text', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'ETA', value: 'eta', type: 'date', data_type: 'date', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'ETD', value: 'etd', type: 'date', data_type: 'date', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Vessel Stay', value: 'vessel_stay', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    // currency conversion changes

    // { name: 'FromCurrency', value: 'pda_currency_from', type: 'select', data_type: 'input', options: [], PAForm: true, readOnly: false },

    { name: 'FromCurrency', value: 'pda_currency_from', type: 'input', data_type: 'input', options: [], PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'ToCurrency', value: 'pda_currency_to', type: 'select', data_type: 'input', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'ROE', value: 'pda_roe', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Voyage', value: 'voyage', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Invoice Ref No', value: 'invoice_ref_no', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: false, createPdaForm: true },

];
// fields array for  fda
const fdaFields: Field[] = [
    { name: 'Client', value: 'client_id', type: 'select', data_type: 'number', options: [], PAForm: false, readOnly: false, createPdaForm: true },
    { name: 'Port Agent', value: 'portagent_id', type: 'select', data_type: 'number', options: [], PAForm: false, readOnly: false, createPdaForm: true },
    { name: 'Country', value: 'country_id', type: 'select', data_type: 'text', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Port', value: 'port_id', type: 'select', data_type: 'text', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'IMO Number', value: 'imo_number', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Vessel', value: 'vessel', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'NRT', value: 'nrt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'GRT', value: 'grt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'RGRT', value: 'rgrt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'LOA', value: 'loa', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Beam', value: 'beam', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Depth', value: 'depth', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Dead Weight', value: 'dwt', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'Cargo', value: 'cargo_id', type: 'select', data_type: 'number', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Purpose', value: 'purpose_id', type: 'select', data_type: 'text', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'ETA', value: 'eta', type: 'date', data_type: 'date', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'ETD', value: 'etd', type: 'date', data_type: 'date', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Vessel Stay', value: 'vessel_stay', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    // currency conversion changes
    // { name: 'FromCurrency', value: 'fda_currency_from', type: 'select', data_type: 'input', options: [], PAForm: true, readOnly: false },
    { name: 'FromCurrency', value: 'fda_currency_from', type: 'input', data_type: 'text', options: [], PAForm: true, readOnly: true, createPdaForm: true },
    { name: 'ToCurrency', value: 'fda_currency_to', type: 'select', data_type: 'input', options: [], PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'ROE', value: 'fda_roe', type: 'input', data_type: 'number', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Voyage', value: 'voyage', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: false, createPdaForm: true },
    { name: 'Invoice Ref No', value: 'invoice_ref_no', type: 'input', data_type: 'text', options: null, PAForm: true, readOnly: false, createPdaForm: true },
];


const convertVesselStayToMinutes = (vesselStay: string): number => {
    if (!vesselStay) return 0;

    const dayMatch = vesselStay.match(/(\d+)\s?(Days?|D)/i);
    const hourMatch = vesselStay.match(/(\d+)\s?(H|Hr)/i);

    const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
    const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;

    return (days * 24 * 60) + (hours * 60);
};

const invoiceReferenceValidation = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';

    if (!value.trim()) {
        return { required: true };
    }
    const patternValid = /^[A-Za-z0-9-_]{3,20}$/.test(value);
    return !patternValid ? { invalidData: true } : null;
};




export { fields, convertVesselStayToMinutes, invoiceReferenceValidation, fdaFields }